export const links = {
  home: '/',
  profile: "/profile",
  portfolio: "/portfolio",
  gallery: "/rest",

  github: 'https://github.com/sinri0809',
}